"use strict";

module.exports = {
  DIRECTION_BOTTOM: "bottom",
  DIRECTION_LEFT: "left",
  DIRECTION_RIGHT: "right",
  DIRECTION_TOP: "top"
};

